import React from "react";
import Chip from "@mui/material/Chip";
import { statusToRole } from "./statusRole";

interface StatusChipProps {
  status: string;
  label?: string;
}

const MUI_COLOR = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "info",
  default: "default",
} as const;

export const StatusChip: React.FC<StatusChipProps> = ({ status, label }) => {
  const role = statusToRole(status);
  return <Chip size="small" color={MUI_COLOR[role]} label={label ?? status} />;
};
